function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "m374.996094 205.996094h-37.265625v-125.996094c0-44.183594-35.820313-80-80-80h-125.460938c-44.183593 0-80 35.816406-80 80v125.996094h-37.269531c-8.285156 0-15 6.714844-15 15v276.003906c0 8.285156 6.714844 15 15 15h359.996094c8.285156 0 15-6.714844 15-15v-276.003906c0-8.285156-6.714844-15-15-15zm-262.726563-115.996094c0-16.570312 13.429688-30 30-30h105.460938c16.570312 0 30 13.429688 30 30v115.996094h-165.460938zm112.726563 273.886719v62.230469c0 5.523437-4.476563 10-10 10h-39.996094c-5.523438 0-10-4.476563-10-10v-62.230469c-10.75-9.089844-17.324219-22.964844-16.414062-38.339844 1.398437-23.671875 20.804687-42.683594 44.5-43.632813 26.550781-1.066406 48.410156 20.144532 48.410156 46.457032 0 14.246094-6.410156 26.984375-16.5 35.515625zm0 0"
});

var SvgLocked = function SvgLocked(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "-61 0 512 512",
    width: "512pt",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLocked, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/locked.1840cb6a.svg";
export { ForwardRef as ReactComponent };